
import React, { useRef, useEffect, useState } from 'react';
//import ReactTagInput from "@pathofdev/react-tag-input";

import styled from 'styled-components/macro';

//import "@pathofdev/react-tag-input/build/index.css";





const TagField = (props) => {
  const [hasFocus, setHasFocus] = useState(false)
  const [tags, setTags] = useState(props.value)
  const [updating, setUpdating] = useState(false)


  const inputRef = useRef()
  let ignoreBlur = false

  useEffect(() => {
    if (hasFocus && inputRef.current) {
      inputRef.current.focus()
    }
  })

  const TagContainer = styled.div`
    cursor:text;
    resize: none;
    // max-height: ${p => p.hasFocus === true ? '143px;' : '143px;'}
    overflow: hidden;
    padding-left:0px;
    margin-right:4px;
    margin-left: 0px;
    width: 99%;
    min-height: 18px;
    word-break: break-all;
    border-radius: 2px;
    overflow-wrap: break-word;
    display: flex;
    flex-direction: column;   
    pointer-events: ${p => {
      if (p.disabled) {
        return 'none;'
      } else {
        return 'auto;'
      }
    }}
    border: ${p => {
      if (p.hasFocus) {
        return '1px solid #0095e0;'
      } else if (p.updating === true) {
        return '1px solid green;'
      } else if (p.canEdit === true && props.assets && props.assets.length > 0) {
        return '1px solid lightgrey;'
      } else {
        return '1px solid transparent;'
      }
    }}
    background-color: transparent;
    outline: none;
    color: black;
    display: inline-block;
    // -webkit-text-fill-color: black;
    font-family: AvenirNextLTPro-Regular, OpenSans-Regular, Lato, sans-serif;
    -webkit-font-smoothing: antialiased;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    -webkit-transition-property: max-height, height;
    -o-transition-property: max-height, height;
    transition-property: max-height, height;
    -webkit-transition-duration: .2s;
    -o-transition-duration: .2s;
    transition-duration: .2s;
    -webkit-transition-timing-function: ease;
    -o-transition-timing-function: ease;
    transition-timing-function: ease;
    :hover {
      border:  ${p => {
      if (p.hasFocus) {
        return '1px solid #0095e0;'
      } else if (p.updating === true) {
        return '1px solid green;'
      } else if (tags !== "(multiple values)") {
        return '1px solid lightgrey;'
      } else {
        return ''
      }
      // p.updating === true ? '1px solid #0095e0;' : '1px solid transparent;'
      //border: ${p => tags !== "(multiple values)" ? "1px solid lightgrey;" : ""}
    }}
    }
  `

  const TagList = styled.div`
  //  max-height: 120px;
    overflow-y: scroll;
  //  overflow-x: hidden;
    position: relative;
    border:0;
    outline:0;
    :focus {
      border: 0;
      outline:0;
    }
  `

  const TagsInput = styled.input`
    border: 0;
    outline: 0;
    display: block;
    line-height: 18px;
    vertical-align: middle;
    color: #333;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: transparent;
    line-height: 19px;
    padding: 3px 5px;
    margin: 0;
    width: 100%;
    height: 24px;
  `

  const TagsDropdown = styled.select`
  border: 0;
  outline: 0;
  display: block;
  line-height: 18px;
  vertical-align: middle;
  color: #333;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: transparent;
  line-height: 19px;
  padding: 3px 5px;
  margin: 0;
  width: 101%;
  height: 18px;
`

  const Tag = styled.div`
    display: inline-block;
    width: auto;
    position: relative;
    margin: 2px 2px 2px 2px;
    padding: 0px 5px;
    font-size: 12px;
    line-height: 14px;
    -webkit-font-smoothing: antialiased;
    border-radius: 3px;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    max-width: 93%;
    height:16px;    
  `
  const TagText = styled.div`
    
    width: 100%;
    padding-right: 11px;
    overflow: hidden;
    white-space: nowrap;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    position: relative;
    display: block;
    color: #fff!important  
  `

  const TagRemoveButton = styled.div`
    position: absolute;
    top: 0;
    right: 1px;
    width: 10px;
    margin: 0 0 0 5px;
    padding: 0;
    cursor: pointer;
    font-family: AvenirNextLTPro-Demi, OpenSans-SemiBold, Lato, sans-serif;
    -webkit-font-smoothing: antialiased;
    opacity: .8;
  `

  const onFocus = (e) => {
    setHasFocus(true)
  }

  const removeTag = (tag) => {
    ignoreBlur = true
    let newTags = tags.filter(o => o !== tag)
    setTags(newTags)
  }

  const Tags = ({ tags }) => {
    if (!tags) return null
    let arr = []
    tags.forEach(tag => {
      // //console.log({ props, TagText, Tag })
      arr.push(
        <Tag style={{ color: props.tagColour, background: props.tagBackground, border: `1px solid ${props.tagBackground}` }} onClick={() => { ignoreBlur = true; inputRef.current.focus(); }}>
          <TagText onClick={() => { ignoreBlur = true; inputRef.current.focus(); }}>
            <div style={{ width: "95%", overflow: "hidden", textOverflow: "ellipsis" }}>
              {tag}
            </div>

          </TagText>
          {props.canEdit ?
            <TagRemoveButton onClick={removeTag.bind(this, tag)}> x </TagRemoveButton>
            : null}
        </Tag>)
    })
    return <TagList onBlur={!props.canEdit ? onBlur.bind(this) : null} tabIndex={!props.canEdit ? 1 : 0} ref={!props.canEdit ? inputRef : null} onClick={() => { ignoreBlur = true; inputRef.current.focus(); }}>{arr}</TagList>
  }

  const onKeyUpValue = (e) => {
    let value = e.target.value
    if (e.keyCode === 13) {
      if (tags.indexOf(value) === -1 && value != "") {
        const newTags = [].concat(tags, value)
        setTags(newTags)
      }
    }
  }


  const onBlur = (e) => {
    if (!props.canEdit) {
      setHasFocus(false)
    } else {
      setTimeout(() => {
        if (ignoreBlur === false) {
          if (JSON.stringify(tags) !== JSON.stringify(props.value)) {
            setUpdating(true)
            let metadata = {
              [props.field]: tags.length > 0 ? tags : ''
            }
            let ids = []
            props.assets.forEach(o => {
              ids.push(o.id)
            })
            ids = ids.join(' OR ')
            props.assetHelper.updateBulk(`id:(${ids})`, metadata)
          } else {
            setHasFocus(false)
          }
        } else {
          ignoreBlur = false
        }
      }, 200)
    }
  }

  const dropdownSelect = (e) => {
    let value = e.target.value
    if (tags.indexOf(value) === -1) {
      const newTags = [].concat(tags, value)
      setTags(newTags)
    }
  }

  //console.log({ props, "this one": "hello" })


  let style = {}
  let disabled = props.assets && props.assets.length === 0 ? true : !props.canEdit
  return (
    <TagContainer disabled={disabled} canEdit={props.canEdit} hasFocus={hasFocus} onClick={onFocus} updating={updating}>
    
      {!hasFocus || updating || tags === "(multiple values)" ?
        <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '3px' }}>
          {tags.length > 0 ? tags === "(multiple values)" ? "(multiple values)" : tags.join(', ') : ''}
        </div>
        :
        <>
          <div>
            <Tags tags={tags} />
          </div>
          
          {!updating && props.canEdit ?

            props.onlyFromValues === true ?
              <TagsDropdown disabled={disabled} ref={inputRef} onChange={dropdownSelect.bind(this)} onBlur={onBlur.bind(this)}>{props.inputValues.map(o => <option>{o}</option>)}</TagsDropdown>
              : <TagsInput disabled={disabled} ref={inputRef} onBlur={onBlur.bind(this)} onKeyUp={onKeyUpValue.bind(this)} style={{ fontSize: "13px", padding: "0px", width: "100%", height: "21px" }} placeholder="Add a tag"></TagsInput>

            :
            null}
        </>
      }
    </TagContainer>

  )

};

export default TagField;